import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CashOptions from '../containers/CashOptions';
import PromoCode from '../containers/PromoCode';
import SelectCustomer from './SelectCustomer';
import ChargeModalSummary from '../containers/ChargeModalSummary';
import Modal from '../../../common/Modal';
import CashChargeButton from '../containers/CashChargeButton';
import GiftCardChargeButton from '../containers/GiftCardChargeButton';
import CardChargeButton from '../containers/CardChargeButton';
import ReaderChargeButton from '../containers/ReaderChargeButton';
import CheckoutSale from '../containers/CheckoutSale';
import RedirectEmptySale from '../containers/RedirectEmptySale';
import ChargeAmount from '../containers/ChargeAmount';
import { PAYMENT_TYPE } from '../../../main/payment/constants';
import Card from './Card';
import AutoHeight from '../../../common/AutoHeight';
import GiftCard from '../containers/GiftCard';
import BackButton from '../containers/BackButton';
import SelectReader from '../../webReader';
import MembershipPaymentWarning from './MembershipPaymentWarning';

const ChargeModal = ({ closeChargeModal, currentPayment, disabled, cardPaymentOnly }) => (
  <Modal
    title="Payment type"
    close={closeChargeModal}
    BackButton={BackButton}
    showCloseButton
  >

    <CheckoutSale display-if={!currentPayment} />
    <RedirectEmptySale />

    <AutoHeight>
      <fieldset className="u-ph medium-and-up-ph++ u-pb++" disabled={disabled}>

        <div className="u-mt">
          <ChargeAmount />
        </div>

        <div className="u-mv">
          <ChargeModalSummary />
        </div>

        <div display-if={!currentPayment}>
          <div className="layout">
            <div className="layout__item u-1/1">
              <SelectCustomer />
            </div>
            <div className="layout__item u-1/1">
              <PromoCode />
            </div>
          </div>

          <div className={classnames('c-payment-types u-mt+', { 'single-column': cardPaymentOnly })}>
            <ReaderChargeButton display-if={!cardPaymentOnly} />
            <CashChargeButton display-if={!cardPaymentOnly} />
            <CardChargeButton />
            <GiftCardChargeButton display-if={!cardPaymentOnly} />
            <MembershipPaymentWarning display-if={cardPaymentOnly} />
          </div>
        </div>

        <CashOptions display-if={currentPayment === PAYMENT_TYPE.cash} />
        <Card display-if={currentPayment === PAYMENT_TYPE.card} />
        <GiftCard display-if={currentPayment === PAYMENT_TYPE.giftCard} />

      </fieldset>
    </AutoHeight>
    <SelectReader />
  </Modal>
);
ChargeModal.propTypes = {
  closeChargeModal: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  currentPayment: PropTypes.string,
  cardPaymentOnly: PropTypes.bool,
};
ChargeModal.defaultProps = {
  currentPayment: null,
  cardPaymentOnly: false,
};

export default ChargeModal;
